// extracted by mini-css-extract-plugin
export default {"noviceRecommendationNav":"index_noviceRecommendationNav__DnOIf"};